import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {
  @Input()
  searchName?: string;

  @Input()
  searchDescription?: string;

  @Output()
  searchNameChange = new EventEmitter<any>();

  constructor() { }

  onSearch() {
    this.searchNameChange.emit(this.searchName);
  }
}
